import { render, staticRenderFns } from "./ViewPeers.vue?vue&type=template&id=28aea5ed&"
import script from "./ViewPeers.vue?vue&type=script&lang=js&"
export * from "./ViewPeers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports